// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__lcIhd","title":"card_title__1WgCV","inActive":"card_inActive__2TSat"};